import { defineAsyncComponent } from 'vue'

export default app => app.component('PlatformHomepage', defineAsyncComponent(() => import('./Homepage')))
